module.exports = __webpack_public_path__ + "static/img/tx2.03b37075.png";